enum PrinterTypes {
  SUNMI_CLOUD = 'SUNMI_CLOUD',
  STAR = 'STAR',
  TERMINAL = 'TERMINAL',
}

export default PrinterTypes;
